import React  from "react";
import { connect } from "react-redux";

import { Header, Grid } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { Loader } from "semantic-ui-react";
import DeleteOrderCalculation from "./DeleteOrderCalculation/DeleteOrderCalculation";
import DeleteCalendarEvents from "./DeleteCalendarEvents/DeleteCalendarEvents";

export const AdminTasks = () => {

    const { t } = useTranslation();

    if (Object.keys(AdminTasks).length === 0) 
        return(
            <Loader active size="large" />
        )
            
    return (
        <Grid padded="horizontally" stackable>
            <Grid.Row>
            <Header className="create-workspace-header">
                {t("account.adminConsole.adminTasks")}
            </Header>
            </Grid.Row>
            <DeleteOrderCalculation />
            <DeleteCalendarEvents />
        </Grid>
    );
}

AdminTasks.propTypes = {
};

AdminTasks.defaultProps = {
    AdminTasks: {},
};

const mapStateToProps = () => ({
});

export default connect(mapStateToProps, {
})(AdminTasks);